export const ActionButtonValue = {
    CLEAN: "clean",
    DIVIDE: "divide",
    MULTIPLY: "multiply",
    MINUS: "minus",
    PLUS: "plus",
    EQUALS: "equals"
}